import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="border-b border-line bg-canvas" data-id="element-27" data-mp="gxzxleqj5fvr">
      <div className="mx-auto max-w-3xl px-4 py-9 text-center sm:px-6" data-id="element-28" data-mp="vu7d41qztt4p">
        <p className="font-display text-[0.65rem] font-bold uppercase tracking-[0.16em] text-accent" data-id="element-29" data-mp="qt082ag8j81q">
          5 bonos especiales incluidos
        </p>
        <h2 id="bonos" className="mt-2 font-display text-lg font-extrabold leading-tight text-ink sm:text-2xl" data-id="element-30" data-mp="zuhk9hqiupl5">
          Además, recibís 5 bonos
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-ink-muted" data-id="element-31" data-mp="1el8booo7bmnq">
          Recursos adicionales para ayudarte a organizarte, practicar y
          aprovechar mejor todo el Mega Pack.
        </p>

        <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-32" data-mp="1jiqmylpoydyw">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-line bg-surface p-4 text-left" data-id="element-33" data-mp="3pqlh6tq08u46" data-mpi={i}>
              <span className="flex items-center gap-1.5 font-display text-[0.65rem] font-bold uppercase tracking-[0.14em] text-accent" data-id="element-34" data-mp="2lcnk1p2fbpw">
                <GiftIcon size={12} data-id="element-35" data-mp="7m0d0ixnbki0" />
                Bono {i + 1} — gratis
              </span>
              <h3 className="mt-1.5 font-display text-sm font-extrabold uppercase leading-tight text-ink" data-id="element-36" data-mp="cja92hfjiuet">
                {bono.title}
              </h3>
              <p className="mt-1.5 text-xs leading-relaxed text-ink-muted sm:text-sm" data-id="element-37" data-mp="lblqjdsof7in">
                {bono.desc}
              </p>
            </Reveal>)}
        </ul>

        <p className="mt-4 inline-block rounded-lg border border-success/30 bg-success-soft px-4 py-2 font-display text-xs font-extrabold uppercase text-success sm:text-sm" data-id="element-38" data-mp="va9w3d3h5u5g">
          Los 5 bonos están gratis con tu compra hoy
        </p>
      </div>
    </section>;
}